<script lang="ts">
  import { loginUser } from '../../../components/auth/LoginUser';

  const isHikari01 = () => {
    return $loginUser.businessCode === 'HIKARI_01';
  };
</script>

<div class="flex flex-col justify-items-center items-center mx-auto">
  <div class="shadow rounded bg-gray-200 w-full content-center p-1">
    <div class="flex-1 m-4">
      <div class="inline-flex justify-items-center items-center min-w-full">
        <div class="mb:font-sm w-full">
          <p>注意事項</p>
          <ul class="list-disc ml-4">
            <li>
              <p>月額料金は初月無料となります(ただし初月解約の場合を除く)</p>
            </li>
          </ul>
          {#if isHikari01()}
            <ul class="list-disc ml-4">
              <li>
                <p>メールアプリ設定時に必要な情報</p>
              </li>
            </ul>
            <ul class="list-none ml-4">
              <li>
                <p>POPサーバ名 (ポート番号)：pop.bb-unext01.jp (110)</p>
              </li>
              <li>
                <p>SMTPサーバ名 (ポート番号)：smtp.bb-unext01.jp (587)</p>
              </li>
              <li>
                <p>IMAPサーバ名 (ポート番号)：imap.bb-unext01.jp (143)</p>
              </li>
            </ul>
          {/if}
        </div>
      </div>
    </div>
  </div>
</div>

<style lang="postcss">
  p {
    @apply text-sm tracking-normal mb-1;
  }
</style>
